import React from 'react';
import PropTypes from 'prop-types';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonGrid,
  IonRow,
  IonCol,
  IonSpinner
} from '@ionic/react';
import { connect } from 'react-redux'

import './Punctuation.css';
import PunctuationActions from '../../../actions/punctuation';
import ErrorAlert from '../../../components/ErrorAlert';

interface IProps {
  getChild: any;
  data: any;
}

interface IState {
  data: any;
  match: any;
}

class Punctuation extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)
    this.state = {data: props.data, match: props.match}
  }

  componentDidMount(){
    if(this.state.data.eva.length === 0){
      this.props.getChild({id: this.state.match.params.child}, "get_child");
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: any){
    this.setState({
      data: nextProps.data,
    });
  }

  loadColor(num: number){
    if (num > 85) {
      return '#0db465';
    }else if (num > 59){
      return '#f9a602';
    }else if(num < 59){
      return '';
    }
  }

  render() {
    const { headerb, nb, user, error401, error, loading } = this.state.data;
    return (
      <IonPage>
        <ErrorAlert/>
        <IonHeader>
          <IonToolbar color="primary">
            <IonTitle>{ !error && !error401 && user.alumno ? user.alumno : error || error401 ? "Error en la petición":"Cargando..." }</IonTitle>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/progress" />
            </IonButtons>
          </IonToolbar>
          <IonToolbar className="toolbarTint">
            <IonTitle style={ !error && !error401 && user.alumno ? {display: "block"}: {display: "none"}} className="ion-text-center">IB: {user.grado} {user.seccion} - {user.turno}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent fullscreen>
          <div style={ loading ? {display: "block", paddingTop: '10%'} : {display: "none"}} className="ion-text-center"><IonSpinner name="circles" color="primary"/></div>
          <h1 style={error || error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">Error en el sistema, consulte con el administador de la aplicación.</h1>
          <h1 style={headerb.length === 0 && !error && !error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">No hay registros</h1>
          <IonGrid className="gridScroll" style={error || error401 && !loading ? {display: "none"} : {display: "block"} }>
            <IonRow className="rowScroll">
              {headerb.map((h:any, key:any) => {
                return (
                  <IonCol key={key} className={ key === 0 ? "headerTable rowTable firstColumn": "headerTable rowTable"} style={ key === 1 ? { marginLeft: '44%', textTransform: 'uppercase' } : {textTransform: 'uppercase'}} size={key === 0 ? "5": "2"}>{h[0]}</IonCol>
                );
              })}
            </IonRow>

            {nb.map((val:any, key:any) => {
              return (
                <IonRow key={key} className="rowScroll">
                  {headerb.map((valh:any, keyh:any) => {
                    if (keyh === 0) {
                      return (
                        <IonCol key={keyh} className="rowTable firstColumn" style={{ height: '50px' }} size="5">{val[valh[0]]}</IonCol>
                      );
                    }else{
                      if (keyh !== headerb.length-1){
                        return (
                          <IonCol key={keyh} className="rowTable" style={ keyh === 1 ? { marginLeft: '44%', height: '50px', backgroundColor: this.loadColor(val[valh[0]]), color: 'white' } : { height: '50px', backgroundColor: this.loadColor(val[valh[0]]), color: 'white' }} size="2">{val[valh[0]]}</IonCol>
                        );
                      }else{
                        return (
                          <IonCol key={keyh} className="rowTable" style={{ backgroundColor: this.loadColor(val[valh[0]]), height: '50px', color: 'white' }} size="2">{val[valh[0]]}</IonCol>
                        );
                      }
                    }
                  })}
                </IonRow>
              );
            })}
          </IonGrid>
        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    getChild: PropTypes.func.isRequired,
    data: state.data
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getChild: (fields: any, typeOptions: string) => dispatch(PunctuationActions.getChild(fields, typeOptions))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Punctuation);
